import {Component, OnDestroy, OnInit} from '@angular/core';
import * as EmployeeActions from './../../store/employee/employee.actions';
import {EmployeeState} from '../../store/employee/employee.reducer';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Predicate} from '@ngrx/entity';
import * as fromEmployeeSelectors from '../../store/employee/employee.selectors';
import {Department, EmployeeJobCode, IEmployee} from '@signal/asp-data-commons';
import { unsubscribeSubscriptions } from '../../shared/services/util.service';
import { TranslateService } from  '@ngx-translate/core';
import { SubscriptionList } from '../../shared/models/asp.types';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-sales-advisor',
  templateUrl: './sales-advisor.component.html',
  styleUrls: ['./sales-advisor.component.scss']
})
export class SalesAdvisorComponent implements OnInit,OnDestroy {


  isLoading$: Observable<boolean>;
  activeEmployees$: Observable<IEmployee[]>;
  inActiveEmployees$: Observable<IEmployee[]>;
  syncStatus$: Observable<string>;
  lastSyncedAt$: Observable<string>;
  isSyncStatusLoading$: Observable<boolean>;
  refreshInterval;
  subs:SubscriptionList = {};
  private isStaffMasterSyncInProgress = false;

  constructor(private readonly employeeStore: Store<EmployeeState>,
              private readonly translate: TranslateService,
              private readonly alertService: AlertService) {
    //this.dispatchActions();
  }

  ngOnInit() {
    this.setupStore();
  }

  private setupStore() {
    /* Store actions dispatchers */
    this.dispatchActions();
    /* Predicates */
    const activeAdvisorPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SALES
        && e.jobCode === EmployeeJobCode.ADVISOR
        && e.isActive;

    const inActiveAdvisorPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SALES
        && e.jobCode === EmployeeJobCode.ADVISOR
        && !e.isActive;

    this.isSyncStatusLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectIsSyncStatusLoading);
    this.syncStatus$ = this.employeeStore.select(fromEmployeeSelectors.selectSyncStatus);
    this.subs.syncstatus = this.syncStatus$.subscribe(status=>{
      if (status === 'SYNC_COMPLETED') {
        if (this.isStaffMasterSyncInProgress) {
          this.alertService.showAlert('otherTexts.syncedSuccessfully', '', '', 5000, false);
        }
        this.isStaffMasterSyncInProgress = false;
        clearInterval(this.refreshInterval);
      } else if (status === 'SYNC_FAILED') {
        this.isStaffMasterSyncInProgress = false;
        clearInterval(this.refreshInterval);
      }
    })
    this.lastSyncedAt$ = this.employeeStore.select(fromEmployeeSelectors.selectSyncStatusLastSyncedAt);
    this.isLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesLoading);
    this.activeEmployees$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesByPredicate, { predicate: activeAdvisorPredicate });
    this.inActiveEmployees$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesByPredicate, { predicate: inActiveAdvisorPredicate });
  }

  private dispatchActions() {
    this.employeeStore.dispatch(new EmployeeActions.LoadEmployees());
    this.employeeStore.dispatch(new EmployeeActions.LoadStaffMasterSyncStatus());
  }

  triggerStaffMasterSync() {
    this.isStaffMasterSyncInProgress = true;
    this.employeeStore.dispatch(new EmployeeActions.TriggerStaffMasterSync());
    this.refreshInterval = setInterval(() => {
      this.employeeStore.dispatch(new EmployeeActions.LoadStaffMasterSyncStatus());
    }, 10 * 1000)
  }
  ngOnDestroy(){
    unsubscribeSubscriptions(this.subs);
  }
}
